<template>
  <section>
    <!-- <filter-component :filters="filters" :showEnd="true" @filter="applyFilters" :types="equipmentTypes" /> -->

    <b-tabs v-model="activeTab" type="is-toggle" style="padding:20px;">
      <b-tab-item :label="`All ()`">
        <orders-table
          :data="results"
          :isLoading="isLoading"
          @reloadOrders="getSoilTestResults"
          :show-status="true"
        >
        </orders-table>
      </b-tab-item>

    </b-tabs>
  </section>
</template>

<script>
import OrdersTable from "@/components/SoilTests/TestResultsTable";
import FilterComponent from "@/components/Shared/Filters";
import {mapActions, mapGetters} from "vuex";
import {mdy} from "@/helpers";

export default {
  name: "SoilTestResults",
  components: {
    OrdersTable,
    FilterComponent,
    d: ["Maize", "Sorghum", "Wheat", "Tobbaco"]
  },

  computed: {
    ...mapGetters(["drivers"]),

    // filters() {
    //   return this.$store.getters.filters;
    // },
    // },

  },
  data() {
    return {
      results: [],
      activeTab: 0,
      isLoading: false,
      filter: this.filters
    };
  },
  created() {
    this.getSoilTestResults(this.filters);
  },
  methods: {
    ...mapActions(["getDrivers"]),
    getSoilTestResults(filters = this.filters) {
      this.results = [];
      this.isLoading = true;

      this.$store
        .dispatch("getSoilTestResults", filters)
        .then(results => {
          this.isLoading = false;
          this.results = results;
        })
        .catch(e => {
          console.log(`Exception when getting soil test results, e:${e}`);
          this.isLoading = false;
        });
    },
    applyFilters({
                   start,
                   end,
                   mobile_number,
                   name,
                   requestNumber,
                   deliveryCities,
                   equipmentTypeId
                 }) {
      end.setHours(24);
      const fromDate = mdy(start);
      const toDate = mdy(end);
      this.$store.commit("setFilters", {
        fromDate,
        toDate,
        mobile_number,
        name,
        requestNumber,
        deliveryCities,
        equipmentTypeId
      });
      this.getSoilTestResults();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SoilTests/TestResults.vue